import { Box, Container,  Grid, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const DeveloperChallenge = () => {
  return (
    <Box
      sx={{
        background: "#f4f8fc",
        py: { xs: 10, md: 8 },
      }}
    >
      <Container maxWidth="lg">

        {/* TITLE */}
        <Typography
          sx={{
            textAlign: "center",
            fontFamily: "Playfair Display",
            fontSize: { xs: 30, md: 42 },
            color: "#0b1f33",
            fontWeight: 600,
            mb: 12,
          }}
        >
          The Developer Challenge
        </Typography>

        <Grid container spacing={6} justifyContent="center">

          {[{
            title: "Common Pain Points",
            items: [
              "Random conversions",
              "Discount-driven closures",
              "Team dependency",
              "Poor visibility",
            ],
            type: "dot",
          },
          {
            title: "The RW Solution",
            items: [
              "Strategic Sales Architecture",
              "Conversion-First Execution",
              "Channel & Team Alignment",
              "Data-Led Growth & Visibility",
            ],
            type: "check",
          }].map((card, i) => (

            <Grid item xs={12} md={5} key={i}>
              <Box
                sx={{
                  p: 6,
                  borderRadius: "30px",
                  position: "relative",
                  overflow: "hidden",

                  // 🔥 DEEP BLUE LUXURY BASE
                  background: `
                    linear-gradient(
                      145deg,
                      #0f63a5 0%,
                      #0c4f85 50%,
                      #083a63 100%
                    )
                  `,

                  // 🔥 GLOW BORDER
                  border: "1px solid rgba(255,255,255,0.15)",

                  // 🔥 OUTER SHADOW (DEPTH)
                  boxShadow: `
                    0 20px 60px rgba(15,99,165,0.35),
                    0 10px 30px rgba(0,0,0,0.25)
                  `,

                  transition: "all 0.4s ease",

                  "&:hover": {
                    transform: "translateY(-12px) scale(1.02)",
                    boxShadow: `
                      0 30px 80px rgba(15,99,165,0.45),
                      0 20px 50px rgba(0,0,0,0.35)
                    `,
                  },

                  // 🔥 GLOSS TOP LIGHT
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-30%",
                    left: "-20%",
                    width: "150%",
                    height: "150%",
                    background: `
                      radial-gradient(
                        circle,
                        rgba(255,255,255,0.25),
                        transparent 60%
                      )
                    `,
                    transform: "rotate(25deg)",
                  },

                  // 🔥 EDGE LIGHT (PREMIUM EFFECT)
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: "30px",
                    border: "1px solid rgba(255,255,255,0.2)",
                    pointerEvents: "none",
                  },
                }}
              >
                {/* TITLE */}
                <Typography
                variant="h6"
                  sx={{
                    color: "#ffffff",
                    fontFamily: '"Playfair Display", serif !important',
                    fontSize: 24,
                    mb: 4,
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  {card.title}
                </Typography>

                {/* ITEMS */}
                {card.items.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      mb: 3,
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {card.type === "dot" ? (
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: "#ffffff",
                          mt: "8px",
                          mr: 2,
                          boxShadow: "0 0 10px rgba(255,255,255,0.6)",
                        }}
                      />
                    ) : (
                      <CheckIcon
                        sx={{
                          color: "#ffffff",
                          mr: 2,
                          mt: "3px",
                          filter: "drop-shadow(0 0 6px rgba(255,255,255,0.6))",
                        }}
                      />
                    )}

                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.9)",
                        fontSize: 16,
                        lineHeight: 1.7,
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}

        </Grid>
      </Container>
    </Box>
  );
};

export default DeveloperChallenge;